import { LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule } from "@angular/common/http";
import { JwtModule } from "@auth0/angular-jwt";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

import { registerLocaleData } from "@angular/common";
import localeEnAu from "@angular/common/locales/en-AU";
registerLocaleData(localeEnAu);

import { AdminModule } from "./admin/admin.module";
import { AppRoutingModule } from "./app-routing.module";
import { AuthModule } from "./auth/auth.module";
import { CoreModule } from "./core/core.module";
import { EnquiryModule } from "./enquiry/enquiry.module";
import { SharedModule } from "./shared/shared.module";

import { AppComponent } from "./app.component";
import { IntroducerSearchService } from "./perspective/introducer-search.service";
import { LoginComponent } from "./login/login.component";
import { PerspectiveComponent } from "./perspective/perspective.component";
import { PerspectiveInterceptor } from "./perspective/perspective.interceptor";
import { PerspectiveService } from "./perspective/perspective.service";

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: () => {
                    return localStorage.getItem("access_token");
                }
            }
        }),

        AdminModule,
        AppRoutingModule,
        AuthModule,
        CoreModule,
        EnquiryModule,
        SharedModule,
    ],

    declarations: [
        AppComponent,
        LoginComponent,
        PerspectiveComponent
    ],

    providers: [
        PerspectiveService,
        IntroducerSearchService,

        { provide: HTTP_INTERCEPTORS, useClass: PerspectiveInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: "en-AU" }
    ],

    bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/app.module.ts